const getDivToPortal = (): HTMLElement => {
	const elementId: HTMLElement | null = document.getElementById('modal-root');
	if (!elementId) {
		return document.createElement('div');
	}
	return elementId;
};

export default getDivToPortal;
